import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  clearDemoSession,
  isDemoPersona,
  orgIdForPersona,
  seedDemoSession,
} from "../../demo/core";
import { demoOrganization } from "../../demo/data";
import { clearZeroDemoPreferences } from "../../demo/session";

/** Zero's home for both personas. */
const DEMO_HOME = "/";

/**
 * Public `/demo/:persona` entry (`outlet` | `recycler`): starts a demo session in
 * this tab (fake tokens + the persona's organization) and boots the real app,
 * which then answers every request from the in-memory demo API.
 */
const DemoEntry: React.FC = () => {
  const { persona } = useParams<{ persona: string }>();

  useEffect(() => {
    if (!isDemoPersona(persona)) {
      window.location.replace("/login");
      return;
    }
    const org = demoOrganization(orgIdForPersona(persona));
    if (!org) {
      window.location.replace("/login");
      return;
    }
    clearDemoSession();
    clearZeroDemoPreferences();
    seedDemoSession(persona, { ...org });
    window.location.replace(DEMO_HOME);
  }, [persona]);

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        bgcolor: "background.default",
        px: 2,
        textAlign: "center",
      }}
    >
      <CircularProgress sx={{ color: "#7C3AED" }} />
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        Preparing your demo…
      </Typography>
      <Typography variant="body2" color="text.secondary" dir="rtl" lang="ar">
        جارٍ تجهيز العرض التجريبي…
      </Typography>
    </Box>
  );
};

export default DemoEntry;
